/* @ngInject */

function dateError($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      let parentForm = element.inheritedData('$formController') || nullFormCtrl; // eslint-disable-line no-undef
      let month = element.find('select[name=cardMonth]');
      let year = element.find('select[name=cardYear]');
      month.on('change keyup', function () {
        $timeout(function () {
          scope.$apply(function () {
            parentForm['cardMonth'].$setValidity('validationError', true);
          });
        });
      });
      year.on('change keyup', function () {
        $timeout(function () {
          scope.$apply(function () {
            parentForm['cardMonth'].$setValidity('validationError', true);
          });
        });
      });
    },
  };
}

export default dateError;
